import React, { FunctionComponent } from 'react';
import { getVideoById } from '../../services/content/video/Video';
import { VideoModel } from '../../services/content/video/models/VideoModel';
import { ImageRatios, ImageSizes } from '../../services/content/image/models/ImageModel';
import { getMainMediaImageByCropRatio } from '../../services/content/image/ImageConfiguration';
import styles from '../../styles/EmbedVideoPage.module.scss';
import Head from 'next/head';

export async function getServerSideProps(context: any) {
    const autoplay =
        context.req.query && context.req.query.autoplay && context.req.query.autoplay === 'true' ? true : false;
    const video = await getVideoById(context.query.id);
    // Check if currentCategory is null or undefined
    if (!video || !video.id || video.status !== 'active') {
        return { notFound: true };
    }
    return {
        props: {
            video: video,
            autoplay: autoplay,
        },
    };
}

export const EmbedVideoPage: FunctionComponent<{ video: VideoModel; autoplay: boolean }> = ({ video, autoplay }) => {
    if (video) {
        const videoFiles = video.urls?.videoFiles ?? [];
        const image = getMainMediaImageByCropRatio(video.mainMedia, ImageRatios.RATIO_16X9, ImageSizes.BIG) ?? '';
        const source = JSON.stringify(
            videoFiles?.map((videoFile) => {
                return { file: videoFile.url, label: videoFile.type };
            }),
        );

        return (
            <>
                <Head>
                    <title>{video.title}</title>
                    <meta name='description' content={video.subtitle ?? ''} />
                    <script async src={'//cdn.jwplayer.com/libraries/KMyl3ECY.js'} />
                    <script async src={'/jwplayer/index.js'} />
                    <link type='text/css' rel='stylesheet' href='/jwplayer/assets/style.css' />
                </Head>

                <div className={`${styles.container}`}>
                    <video
                        className='video-player'
                        src={videoFiles?.[0]?.url ?? ''}
                        poster={image}
                        preload='none'
                        data-type='vod'
                        data-title={JSON.stringify(video.title)}
                        data-autoplay={`"autoplay": ${autoplay}, "notonmobile": false, "viewableplay": false`}
                        data-sources={source}></video>
                </div>
            </>
        );
    }

    return null;
};

export default EmbedVideoPage;
